// Aardwolf's wear-location vocabulary is fixed and closed (the "Wear Flag"
// column from the game's own wear locations reference, `help wearlocs`
// in-game) - unlike `category`, which the API defines itself and can grow,
// this list is a game fact unlikely to ever change. So it's hardcoded here
// rather than fetched from an endpoint, the same way the Status filter's
// options (listed/sold/expired) are hardcoded in Market.tsx rather than
// fetched - see lightclanApi's utils/marketSlots.ts for the source list
// this mirrors.
export const MARKET_SLOTS = [
  "above",
  "arms",
  "back",
  "body",
  "ear",
  "eyes",
  "feet",
  "finger",
  "float",
  "hands",
  "head",
  "hold",
  "legs",
  "light",
  "medal",
  "neck",
  "portal",
  "shield",
  "sleeping",
  "torso",
  "waist",
  "wield",
  "wrist"
] as const;
